const Signatures = () => (
  <div style={{ paddingInline: '20px' }}>
    <ul style={{
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '0',
      margin: '0 !important'
    }}>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li>_____________</li>
          <li style={{ marginTop: '10px' }}>Admission Date</li>
        </ul>
      </li>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li>___________________</li>
          <li style={{ marginTop: '10px' }}>Sign Of Father/Guardian</li>
        </ul>
      </li>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li>_______________</li>
          <li style={{ marginTop: '10px' }}>Sign Of Candidate.</li>
        </ul>
      </li>
    </ul>

    <ul style={{
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: '20px',
      padding: '0px !important',
      margin: '0px'
    }}>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li>______________</li>
          <li style={{ marginTop: '10px' }}>Sign Of Principal</li>
        </ul>
      </li>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li>_____________</li>
          <li style={{ marginTop: '10px' }}>Sign Of convenor</li>
        </ul>
      </li>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li>_____________</li>
          <li style={{ marginTop: '10px' }}>Admission Cell</li>
        </ul>
      </li>
    </ul>
  </div>
);

export default Signatures;